import { t } from 'i18next';
import { Affixes } from '../../../../../../../shared/types/keystoneAffixTypes';
import { RunTimeTooltipContent } from '../../../../../../../shared/frontend/components/presentational/runTimeTooltip';
import { getBaseAffix } from '../../../../../shared/utils';

export function KeystoneRunTimeInfo(props: { run: any; showHeader?: boolean }) {
  const { run } = props;
  const modifiers = run.weekly_modifiers?.modifiers || run.weekly_modifiers || [];

  const baseAffix = getBaseAffix(modifiers.map((m: any) => m.id));

  const header =
    props.showHeader && baseAffix ? (
      <div className="text-underline">
        Best {t(`raids:${run.dungeon.slug}.acronym`)}: {baseAffix === Affixes.TYRANNICAL ? 'Tyrannical' : 'Fortified'} +
        {run.mythic_level}
      </div>
    ) : null;

  return (
    <RunTimeTooltipContent
      className="slds-text-body--small"
      run={{
        clearTimeMs: run.clear_time_ms,
        keystoneTimeMs: run.keystone_time_ms,
        completedAt: run.completed_at
      }}
      prefix={header}
      showRelativeDate
      showAbsoluteDate
    />
  );
}
